export enum ReadOnlyPermission {
  View = 'Read-Only',
}

export enum SetupPermission {
  ManageWallets = 'Setup.Manage Wallets',
  ManageERP = 'Setup.Manage ERP',
}

export enum BookkeepingPermission {
  EditTransactions = 'Bookkeeping.Edit Transactions',
  ManageContacts = 'Bookkeeping.Manage Contacts',
  ManageRules = 'Bookkeeping.Manage Rules',
  SyncToERP = 'Bookkeeping.Sync To ERP',
  DownloadReports = 'Bookkeeping.Download Reports',
}

export enum PaymentsPermission {
  CreateBills = 'Payments.Create Bills',
  ReconcileBills = 'Payments.Reconcile Bills',
  ApproveBills = 'Payments.Approve Bills',
  PayBills = 'Payments.Pay Bills',
}

export enum OrganizationsPermission {
  ManageUsers = 'Organizations.Manage Users',
  ManageRoles = 'Organizations.Manage Roles',
  AssignUserRoles = 'Organizations.Assign User Roles',
  ManageOrganizations = 'Organizations.Manage Organizations',
}

/** @deprecated use {@link Permission} instead */
export type PermissionTypes =
  | ReadOnlyPermission
  | SetupPermission
  | BookkeepingPermission
  | PaymentsPermission
  | OrganizationsPermission;

/** @deprecated use {@link Permission} instead */
export const PermissionsList = {
  ReadOnlyPermission: ReadOnlyPermission,
  SetupPermission: SetupPermission,
  BookkeepingPermission: BookkeepingPermission,
  PaymentsPermission: PaymentsPermission,
  OrganizationsPermission: OrganizationsPermission,
};

export enum Permission {
  // Read-Only
  View = ReadOnlyPermission.View,

  // Setup
  ManageWallets = SetupPermission.ManageWallets,
  ManageERP = SetupPermission.ManageERP,

  // Bookkeeping
  EditTransactions = BookkeepingPermission.EditTransactions,
  ManageContacts = BookkeepingPermission.ManageContacts,
  ManageRules = BookkeepingPermission.ManageRules,
  SyncToERP = BookkeepingPermission.SyncToERP,
  DownloadReports = BookkeepingPermission.DownloadReports,

  // Payments
  CreateBills = PaymentsPermission.CreateBills,
  ReconcileBills = PaymentsPermission.ReconcileBills,
  ApproveBills = PaymentsPermission.ApproveBills,
  PayBills = PaymentsPermission.PayBills,

  // Organizations
  ManageUsers = OrganizationsPermission.ManageUsers,
  ManageRoles = OrganizationsPermission.ManageRoles,
  AssignUserRoles = OrganizationsPermission.AssignUserRoles,
  ManageOrganizations = OrganizationsPermission.ManageOrganizations,
}

export enum RoleName {
  Viewer = 'Viewer',
  Auditor = 'Auditor',
  Approver = 'Approver',
  Bookkeeper = 'Bookkeeper',
  FinanceManager = 'FinanceManager',
  Admin = 'Admin',
}
